import { useUserStore } from '@/stores';

export type DocumentFontSize = 'xs' | 'sm' | 'base' | 'lg';

export const DOC_FONT_SIZE_OPTIONS: { value: DocumentFontSize; label: string; size: string }[] = [
  { value: 'xs', label: 'Extra Small', size: '12px' },
  { value: 'sm', label: 'Small', size: '14px' },
  { value: 'base', label: 'Medium', size: '16px' },
  { value: 'lg', label: 'Large', size: '18px' },
];

export function useDocumentFontSize() {
  const documentFontSize = useUserStore(state =>
    (state.userSettings.documentFontSize as DocumentFontSize) || 'sm'
  );
  const updateUserSettings = useUserStore(state => state.updateUserSettings);

  const setDocumentFontSize = (value: DocumentFontSize) => {
    updateUserSettings('documentFontSize', value);
  };

  const getFontSizeStyle = (): React.CSSProperties => {
    const option = DOC_FONT_SIZE_OPTIONS.find(o => o.value === documentFontSize);
    return { fontSize: option?.size || '14px' };
  };

  return { documentFontSize, setDocumentFontSize, getFontSizeStyle };
}
